const CreditIcon = ({ className }: { className?: string }) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1694_1449)">
<path d="M39 12H9C8 12 7 13 7 14.0001L7 34C7 35 8 36 9 36H39C40 36 41 35 41 34V14.0001C41 13 40 12 39 12ZM39 34H9V21H39V34ZM39 17H9V14H39V17Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1694_1449">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>

);

export default CreditIcon;
